module.exports = __webpack_public_path__ + "img/bonnier_publications-copy.e0306144.png";